PluginBadgesView = require 'views/plugin/plugin-badges-view'
PluginCardDetailBadgeView = require 'views/plugin/plugin-card-detail-badge-view'
trackUe = require 'debug/trackUe'

module.exports = class PluginCardDetailBadgesView extends PluginBadgesView
  tagName: 'div'
  badgeView: PluginCardDetailBadgeView

  runnerOptions: ->
    command: 'card-detail-badges'
    board: @model.getBoard()
    card: @model

  trackBadges: (idPlugin) ->
    if !@trackedDetailsBadges?
      @trackedDetailsBadges = {}
    if !@trackedDetailsBadges[idPlugin]
      @trackedDetailsBadges[idPlugin] = true
      trackUe('card details', 'views', 'Power-Up', '', '', 'card-detail-badges', idPlugin)



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-card-detail-badges-view.coffee